<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="web-qr-screen">

    <div class="page-heading">
      <h3>
        <span class="back-circle" (click)="goBack()" nz-tooltip
          nzTooltipTitle="{{ 'webQr.back' | translate }}">
          <i class="fa-solid fa-angle-left"></i>
        </span>
        {{ 'webQr.title' | translate }}
        <small class="contest-name" *ngIf="contestName">{{ contestName }}</small>
      </h3>
      <div class="heading-right">
        <button class="btn btn-primary" *ngIf="activeTab === 'instances'" (click)="openCreateModal()"
          [disabled]="!contestId">
          <i class="fa-solid fa-plus me-2"></i>
          {{ 'webQr.createQr' | translate }}
        </button>
      </div>
    </div>

    <div class="custom-tabs-container">
      <div class="custom-tabs-header">
        <ul class="custom-nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link" role="tab" [class.active]="activeTab === 'instances'"
              (click)="switchTab('instances')">
              {{ 'webQr.listTitle' | translate }}
              <span *ngIf="qrInstances.length">({{ qrInstances.length }})</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="tab" [class.active]="activeTab === 'report'" (click)="switchTab('report')">
              {{ 'webQr.report.title' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="luqta-card" *ngIf="activeTab === 'instances'">
      <div class="card-heading">
        <h3>
          {{ 'webQr.listTitle' | translate }}
          <span *ngIf="qrInstances.length">({{ qrInstances.length }})</span>
        </h3>
        <p class="card-subtitle">{{ 'webQr.listSubtitle' | translate }}</p>
      </div>

      <nz-table #qrTable [nzData]="qrInstances" [nzBordered]="true"
        [nzScroll]="{ x: '1470px' }" [nzPageSize]="10" [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50]" [nzNoResult]="emptyTpl">
        <thead>
          <tr>
            <th nzWidth="60px">#</th>
            <th nzWidth="180px">{{ 'webQr.form.label.label' | translate }}</th>
            <th nzWidth="130px">{{ 'webQr.form.placementType.label' | translate }}</th>
            <th nzWidth="110px">{{ 'webQr.status.label' | translate }}</th>
            <th nzWidth="90px">{{ 'webQr.scans' | translate }}</th>
            <th nzWidth="130px">{{ 'webQr.capacity' | translate }}</th>
            <th nzWidth="260px">{{ 'webQr.shortLink' | translate }}</th>
            <th nzWidth="170px">{{ 'webQr.form.expiresAt.label' | translate }}</th>
            <th nzWidth="160px">{{ 'webQr.createdAt' | translate }}</th>
            <th nzWidth="200px">{{ 'webQr.form.notes.label' | translate }}</th>
            <th nzWidth="110px" nzRight>{{ 'allContests.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let instance of qrTable.data; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ instance.label || '-' }}</td>
            <td>
              <span class="placement-badge" [class.digital]="instance.placement_type === 'digital'">
                {{ getPlacementLabel(instance.placement_type) }}
              </span>
            </td>
            <td>
              <span class="status-badge" [ngClass]="getStatusKey(instance)">
                {{ 'webQr.status.' + getStatusKey(instance) | translate }}
              </span>
            </td>
            <td>{{ instance.scan_count ?? 0 }}</td>
            <td>
              <!-- An uncapped code shows how many joined and nothing else — a
                   "of unlimited" reads as a bug, and "0 left" would be a lie. -->
              <ng-container *ngIf="instance.max_participants; else uncapped">
                <span class="capacity-cell" [class.is-full]="instance.is_full">
                  {{ instance.joined_here ?? 0 }} / {{ instance.max_participants }}
                </span>
                <span class="status-badge inactive ms-1" *ngIf="instance.is_full">
                  {{ 'webQr.full' | translate }}
                </span>
              </ng-container>
              <ng-template #uncapped>
                <span class="text-muted" nz-tooltip
                  nzTooltipTitle="{{ 'webQr.noCap' | translate }}">
                  {{ instance.joined_here ?? 0 }}
                </span>
              </ng-template>
            </td>
            <td>
              <div class="link-cell" *ngIf="instance.short_link; else noLink">
                <span class="link-text" [title]="instance.short_link">{{ instance.short_link }}</span>
                <i class="fa-solid fa-copy copy-btn" (click)="copyLink(instance.short_link!)" nz-tooltip
                  nzTooltipTitle="{{ 'webQr.copyLink' | translate }}"></i>
              </div>
              <ng-template #noLink>-</ng-template>
            </td>
            <td>
              <span *ngIf="instance.expires_at; else noExpiry" [class.expired]="isExpired(instance)">
                {{ instance.expires_at | date: 'dd/MM/yy hh:mm a' }}
              </span>
              <ng-template #noExpiry>
                <span class="text-muted">{{ 'webQr.noExpiry' | translate }}</span>
              </ng-template>
            </td>
            <td>{{ instance.created_at ? (instance.created_at | date: 'dd/MM/yy hh:mm a') : '-' }}</td>
            <td>
              <span [title]="instance.notes">
                {{ instance.notes ? (instance.notes.length > 40 ? (instance.notes | slice: 0:40) + '...' : instance.notes) : '-' }}
              </span>
            </td>
            <td nzRight>
              <div class="table-action-btns">
                <i class="fa-solid fa-qrcode action-icon" (click)="openPreview(instance)" nz-tooltip
                  nzTooltipTitle="{{ 'webQr.viewQr' | translate }}"></i>
                <i class="fa-solid fa-pen action-icon" (click)="openEditModal(instance)" nz-tooltip
                  nzTooltipTitle="{{ 'webQr.editQr' | translate }}"></i>
                <i class="fa-solid fa-user-group action-icon" (click)="openParticipantsDrawer(instance)" nz-tooltip
                  nzTooltipTitle="View Participants"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <ng-template #emptyTpl>
        <div class="qr-empty-state">
          <i class="fa-solid fa-qrcode"></i>
          <h4>{{ 'webQr.emptyTitle' | translate }}</h4>
          <p>{{ 'webQr.emptySubtitle' | translate }}</p>
        </div>
      </ng-template>
    </div>

    <!-- Scan report -->
    <div class="luqta-card" *ngIf="activeTab === 'report'">
      <div class="card-heading">
        <h3>
          {{ 'webQr.report.title' | translate }}
          <span *ngIf="visibleReportRows.length">({{ visibleReportRows.length }})</span>
        </h3>
        <p class="card-subtitle">{{ 'webQr.report.subtitle' | translate }}</p>
      </div>

      <div class="qr-report-summary" *ngIf="reportSummary">
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.totalScans' | translate }}</span>
          <span class="stat-value">{{ reportSummary.total_scans ?? 0 }}</span>
        </div>
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.reachedContest' | translate }}</span>
          <span class="stat-value">{{ reportSummary.scans_reaching_contest ?? 0 }}</span>
        </div>
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.activeInstances' | translate }}</span>
          <span class="stat-value">
            {{ reportActiveInstances }}<small>/{{ reportSummary.instances ?? 0 }}</small>
          </span>
        </div>
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.joins' | translate }}</span>
          <span class="stat-value">{{ reportSummary.joins ?? 0 }}</span>
        </div>
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.completions' | translate }}</span>
          <span class="stat-value">{{ reportSummary.completions ?? 0 }}</span>
        </div>
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.winners' | translate }}</span>
          <span class="stat-value">{{ reportSummary.winners ?? 0 }}</span>
        </div>
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.joinRate' | translate }}</span>
          <span class="stat-value">{{ ratePct(reportSummary.join_rate_pct) }}</span>
        </div>
        <div class="stat">
          <span class="stat-label">{{ 'webQr.report.summary.completionRate' | translate }}</span>
          <span class="stat-value">{{ ratePct(reportSummary.completion_rate_pct) }}</span>
        </div>
      </div>

      <div class="top-filters">
        <div class="search-bar">
          <div class="icon">
            <i class="fa-solid fa-magnifying-glass" (click)="loadReport(true)"></i>
          </div>
          <input type="text" class="form-control" [(ngModel)]="reportName"
            [placeholder]="'webQr.report.searchPlaceholder' | translate"
            (keyup.enter)="loadReport(true)" autocapitalize="off" style="text-transform: none;" />
        </div>
        <button class="btn btn-light filter-btn" (click)="openFilterModal()">
          <i class="fa-solid fa-filter"></i>
          <span>{{ 'contests.filter' | translate }}</span>
          <!-- Animated red dot when filters are active -->
          <span *ngIf="hasActiveFilters()" class="filter-active-dot"
            (click)="clearAllFilters(); $event.stopPropagation()"
            title="{{ 'common.clear-filters-tooltip' | translate }}">
          </span>
        </button>
      </div>

      <nz-table #reportTable [nzData]="visibleReportRows" [nzBordered]="true"
        [nzScroll]="{ x: '1500px' }" [nzFrontPagination]="false" [nzTotal]="reportTotal"
        [nzPageIndex]="reportPage" [nzPageSize]="reportPerPage" [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50]" [nzNoResult]="reportEmptyTpl"
        (nzPageIndexChange)="onReportPageChange($event)" (nzPageSizeChange)="onReportPageSizeChange($event)">
        <thead>
          <tr>
            <th nzWidth="60px">#</th>
            <th nzWidth="200px">{{ 'webQr.form.label.label' | translate }}</th>
            <th nzWidth="130px">{{ 'webQr.form.placementType.label' | translate }}</th>
            <th nzWidth="100px">{{ 'webQr.scans' | translate }}</th>
            <th nzWidth="120px">{{ 'webQr.report.redirected' | translate }}</th>
            <th nzWidth="110px">{{ 'webQr.report.expired' | translate }}</th>
            <th nzWidth="110px">{{ 'webQr.report.inactive' | translate }}</th>
            <th nzWidth="140px">{{ 'webQr.report.contestClosed' | translate }}</th>
            <th nzWidth="120px">{{ 'webQr.report.notFound' | translate }}</th>
            <th nzWidth="110px">{{ 'webQr.report.reachRate' | translate }}</th>
            <th nzWidth="120px">{{ 'webQr.status.label' | translate }}</th>
            <th nzWidth="170px">{{ 'webQr.report.expiresAt' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of reportTable.data; let idx = index">
            <td>{{ (reportPage - 1) * reportPerPage + idx + 1 }}</td>
            <td>{{ row.label || '-' }}</td>
            <td>
              <span class="placement-badge" [class.digital]="row.placement_type === 'digital'">
                {{ getPlacementLabel(row.placement_type) }}
              </span>
            </td>
            <td>{{ row.scans }}</td>
            <td>{{ outcome(row, 'redirected') }}</td>
            <td>{{ outcome(row, 'expired') }}</td>
            <td>{{ outcome(row, 'inactive') }}</td>
            <td>{{ outcome(row, 'contest_closed') }}</td>
            <td>{{ outcome(row, 'not_found') }}</td>
            <td>{{ ratePct(row.reach_rate_pct) }}</td>
            <td>
              <span class="status-badge" [ngClass]="getStatusKey(row)">
                {{ 'webQr.status.' + getStatusKey(row) | translate }}
              </span>
            </td>
            <td>{{ row.expires_at ? (row.expires_at | date: 'dd/MM/yy hh:mm a') : ('webQr.noExpiry' | translate) }}</td>
          </tr>
        </tbody>
      </nz-table>

      <ng-template #reportEmptyTpl>
        <div class="qr-empty-state">
          <i class="fa-solid fa-chart-simple"></i>
          <ng-container *ngIf="reportRowsFilteredOut; else noScansTpl">
            <h4>{{ 'webQr.report.noMatchTitle' | translate }}</h4>
            <p>{{ 'webQr.report.noMatchSubtitle' | translate }}</p>
          </ng-container>
          <ng-template #noScansTpl>
            <h4>{{ 'webQr.report.emptyTitle' | translate }}</h4>
            <p>{{ 'webQr.report.emptySubtitle' | translate }}</p>
          </ng-template>
        </div>
      </ng-template>
    </div>

  </div>
</div>

<!-- Create / edit QR instance modal -->
<nz-modal [(nzVisible)]="isModalVisible" [nzTitle]="(editingInstance ? 'webQr.editQr' : 'webQr.createQr') | translate" nzCentered
  [nzFooter]="createFooterTpl" (nzOnCancel)="closeCreateModal()" nzClassName="luqta-custom-modal web-qr-modal"
  nzWidth="620px">
  <ng-container *nzModalContent>
    <form [formGroup]="qrForm" class="web-qr-form">
      <div class="row gy-3">
        <div class="col-md-12">
          <label class="form-label">
            {{ 'webQr.form.label.label' | translate }}<span class="req">*</span>
            <span class="label_subtext" nz-tooltip nzTooltipTitle="{{ 'webQr.form.label.tooltip' | translate }}"
              nzTooltipPlacement="top">
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </label>
          <input type="text" class="form-control" formControlName="label" maxlength="100"
            [placeholder]="'webQr.form.label.placeholder' | translate" />
          <small class="error text-danger" *ngIf="isFieldInvalid('label')">
            {{ 'addContestsValidation.required' | translate }}
          </small>
        </div>

        <div class="col-md-12">
          <label class="form-label">
            {{ 'webQr.form.placementType.label' | translate }}<span class="req">*</span>
            <span class="label_subtext" nz-tooltip
              nzTooltipTitle="{{ 'webQr.form.placementType.tooltip' | translate }}" nzTooltipPlacement="top">
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </label>
          <div class="select-options" [class.readonly-options]="!!editingInstance">
            <a href="javascript:void(0)" class="option" nz-tooltip
              nzTooltipTitle="{{ 'webQr.form.placementType.printTooltip' | translate }}"
              [class.active]="qrForm.getRawValue().placement_type === 'print'"
              (click)="!editingInstance && qrForm.patchValue({ placement_type: 'print' })">
              {{ 'webQr.placement.print' | translate }}
            </a>
            <a href="javascript:void(0)" class="option" nz-tooltip
              nzTooltipTitle="{{ 'webQr.form.placementType.digitalTooltip' | translate }}"
              [class.active]="qrForm.getRawValue().placement_type === 'digital'"
              (click)="!editingInstance && qrForm.patchValue({ placement_type: 'digital' })">
              {{ 'webQr.placement.digital' | translate }}
            </a>
          </div>
          <small class="field-hint" *ngIf="editingInstance">{{ 'webQr.form.placementType.lockedHint' | translate }}</small>
        </div>

        <div class="col-md-12">
          <label class="form-label">
            {{ 'webQr.form.baseUrl.label' | translate }}<span class="req">*</span>
            <span class="label_subtext" nz-tooltip nzTooltipTitle="{{ 'webQr.form.baseUrl.tooltip' | translate }}"
              nzTooltipPlacement="top">
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </label>
          <nz-select formControlName="base_url" style="width: 100%" [nzLoading]="isDomainsLoading"
            [nzPlaceHolder]="'webQr.form.baseUrl.placeholder' | translate" [nzOptionOverflowSize]="5"
            [nzNotFoundContent]="'webQr.form.baseUrl.empty' | translate">
            <nz-option *ngFor="let option of qrDomainOptions" nzCustomContent [nzValue]="option.base"
              [nzDisabled]="option.disabled" [nzLabel]="option.label + ' — ' + option.base">
              {{ option.label }} — {{ option.base }}
              <small class="ms-2 fw-semibold text-warning" *ngIf="option.statusKey">{{ option.statusKey | translate }}</small>
            </nz-option>
          </nz-select>
          <small class="field-hint" *ngIf="qrLinkPreview">
            {{ 'webQr.form.baseUrl.hint' | translate }} <span class="qr-link-preview">{{ qrLinkPreview }}</span>
          </small>
          <small class="error text-danger d-block" *ngIf="isFieldInvalid('base_url')">
            {{ 'addContestsValidation.required' | translate }}
          </small>
        </div>

        <div class="col-md-6" *ngIf="editingInstance">
          <label class="form-label">
            {{ 'webQr.form.isActive.label' | translate }}
            <span class="label_subtext" nz-tooltip nzTooltipTitle="{{ 'webQr.form.isActive.tooltip' | translate }}"
              nzTooltipPlacement="top">
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </label>
          <div class="select-options">
            <a href="javascript:void(0)" class="option" [class.active]="qrForm.get('is_active')?.value === true"
              (click)="qrForm.patchValue({ is_active: true })">
              {{ 'webQr.status.active' | translate }}
            </a>
            <a href="javascript:void(0)" class="option" [class.active]="qrForm.get('is_active')?.value === false"
              (click)="qrForm.patchValue({ is_active: false })">
              {{ 'webQr.status.inactive' | translate }}
            </a>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">
            {{ 'webQr.form.expiresAt.label' | translate }}
            <span class="label_subtext" nz-tooltip nzTooltipTitle="{{ 'webQr.form.expiresAt.tooltip' | translate }}"
              nzTooltipPlacement="top">
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </label>
          <nz-date-picker formControlName="expires_at" nzShowTime nzFormat="dd/MM/yy hh:mm a" style="width: 100%"
            [nzDisabledDate]="disabledExpiryDate" [nzDisabledTime]="disabledExpiryTime"
            [nzPlaceHolder]="'webQr.form.expiresAt.placeholder' | translate">
          </nz-date-picker>
          <small class="error text-danger d-block" *ngIf="isFieldInvalid('expires_at')">
            {{ 'webQr.form.expiresAt.past' | translate }}
          </small>
          <small class="field-hint">
            {{ (editingInstance ? 'webQr.form.expiresAt.clearHint' : 'webQr.form.expiresAt.hint') | translate }}
          </small>
        </div>

        <div class="col-md-6">
          <label class="form-label">
            {{ 'webQr.form.maxParticipants.label' | translate }}
            <span class="label_subtext" nz-tooltip
              nzTooltipTitle="{{ 'webQr.form.maxParticipants.tooltip' | translate }}" nzTooltipPlacement="top">
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </label>
          <input type="number" class="form-control" formControlName="max_participants" min="1" step="1"
            inputmode="numeric" (keydown)="blockNonDigitKey($event)" (paste)="blockNonDigitPaste($event)"
            [max]="capBudget.available ?? null"
            [placeholder]="'webQr.form.maxParticipants.placeholder' | translate" />

          <!-- Three different things to say, so they get three hints rather than
               one that hedges: what is left to allocate, that an open code makes
               that number approximate, and that blank means no limit. -->
          <small class="field-hint" *ngIf="capBudget.available !== null">
            {{ 'webQr.form.maxParticipants.available' | translate: {
                 available: capBudget.available, limit: capBudget.limit
               } }}
          </small>
          <small class="field-hint text-warning" *ngIf="capBudget.uncapped > 0">
            {{ 'webQr.form.maxParticipants.uncappedWarning' | translate: { count: capBudget.uncapped } }}
          </small>
          <small class="field-hint">
            {{ 'webQr.form.maxParticipants.hint' | translate }}
          </small>
          <small class="error text-danger" *ngIf="isFieldInvalid('max_participants')">
            {{ (qrForm.get('max_participants')?.hasError('pattern')
                ? 'webQr.form.maxParticipants.wholeNumber'
                : 'webQr.form.maxParticipants.min') | translate }}
          </small>
        </div>

        <div class="col-md-12">
          <label class="form-label">
            {{ 'webQr.form.notes.label' | translate }}
            <span class="label_subtext" nz-tooltip nzTooltipTitle="{{ 'webQr.form.notes.tooltip' | translate }}"
              nzTooltipPlacement="top">
              <i class="fa-solid fa-circle-info"></i>
            </span>
          </label>
          <textarea class="form-control" formControlName="notes" rows="3" maxlength="500"
            [placeholder]="'webQr.form.notes.placeholder' | translate"></textarea>
        </div>
      </div>
    </form>
  </ng-container>
</nz-modal>

<ng-template #createFooterTpl>
  <div class="d-flex justify-content-between w-100">
    <button type="button" class="btn btn-dark" (click)="closeCreateModal()" [disabled]="isSaving">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="submitQrInstance()" [disabled]="isSaving">
      {{ (isSaving
            ? (editingInstance ? 'webQr.saving' : 'webQr.creating')
            : (editingInstance ? 'webQr.save' : 'common.create')) | translate }}
    </button>
  </div>
</ng-template>

<!-- QR preview modal -->
<nz-modal [nzVisible]="!!previewInstance" [nzTitle]="previewInstance?.label || ('webQr.viewQr' | translate)" nzCentered
  [nzFooter]="null" (nzOnCancel)="closePreview()" (nzVisibleChange)="onPreviewVisibleChange($event)"
  nzClassName="luqta-custom-modal web-qr-modal" nzWidth="400px">
  <ng-container *nzModalContent>
    <div class="qr-preview">
      <div id="qrPreviewWrap">
        <!-- Level H (30% error correction) is what lets the centre logo cover
             part of the code without breaking the scan. -->
        <nz-qrcode *ngIf="previewInstance?.qr_value" [nzValue]="previewInstance!.qr_value!"
          [nzSize]="qrPreviewSize" nzLevel="H" [nzIcon]="qrLogoSrc"
          [nzIconSize]="qrPreviewIconSize"></nz-qrcode>
      </div>
      <p class="qr-preview-empty" *ngIf="!previewInstance?.qr_value">{{ 'webQr.noQrValue' | translate }}</p>
      <div class="link-cell mt-3" *ngIf="previewInstance?.short_link">
        <span class="link-text">{{ previewInstance!.short_link }}</span>
        <i class="fa-solid copy-btn" [class.fa-copy]="!previewLinkCopied" [class.fa-check]="previewLinkCopied"
          (click)="copyLink(previewInstance!.short_link!, true)" nz-tooltip
          nzTooltipTitle="{{ (previewLinkCopied ? 'webQr.linkCopied' : 'webQr.copyLink') | translate }}"></i>
      </div>
      <div class="qr-preview-actions mt-3" *ngIf="previewInstance?.qr_value">
        <button class="btn btn-primary" (click)="downloadQr(previewInstance)">
          <i class="fa-solid fa-download me-2"></i>
          {{ 'webQr.downloadQr' | translate }}
        </button>
      </div>

      <div class="qr-share-row" *ngIf="previewInstance?.short_link">
        <span class="qr-share-label">{{ 'webQr.shareQr' | translate }}</span>
        <div class="qr-share-icons">
          <a class="social-icon whatsapp" (click)="shareQrOn('whatsapp')"
            title="{{ 'common.share-whatsapp-tooltip' | translate }}">
            <i class="fa-brands fa-whatsapp"></i>
          </a>
          <a class="social-icon facebook" (click)="shareQrOn('facebook')"
            title="{{ 'common.share-facebook-tooltip' | translate }}">
            <i class="fa-brands fa-facebook"></i>
          </a>
          <a class="social-icon twitter" (click)="shareQrOn('twitter')"
            title="{{ 'common.share-twitter-tooltip' | translate }}">
            <i class="fa-brands fa-twitter"></i>
          </a>
          <a class="social-icon linkedin" (click)="shareQrOn('linkedin')"
            title="{{ 'common.share-linkedin-tooltip' | translate }}">
            <i class="fa-brands fa-linkedin"></i>
          </a>
          <a class="social-icon email" (click)="shareQrOn('email')"
            title="{{ 'common.share-email-tooltip' | translate }}">
            <i class="fa-solid fa-envelope"></i>
          </a>
          <a class="social-icon copy" (click)="shareQrOn('copy')"
            title="{{ 'webQr.copyLink' | translate }}">
            <i class="fa-solid fa-copy"></i>
          </a>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>

<!-- Scan report filters -->
<app-filter-modal [(isVisible)]="filterModalVisible" [config]="reportFilterConfig" [initialFilters]="currentFilters"
  [modalTitle]="'webQr.report.filterTitle' | translate" (filtersApplied)="onFiltersApplied($event)"
  (filtersReset)="onFiltersReset()"></app-filter-modal>

<!-- Participants Drawer -->
<nz-drawer
  [nzVisible]="isParticipantsDrawerVisible"
  [nzWidth]="'750px'"
  [nzTitle]="participantsDrawerTitleTpl"
  (nzOnClose)="closeParticipantsDrawer()"
  nzPlacement="right"
  nzClassName="luqta-custom-drawer participants-drawer">
  <ng-container *nzDrawerContent>
    <div class="participants-drawer-content">
      <!-- Subtitle info banner -->
      <div class="drawer-info-banner mb-3" *ngIf="selectedInstanceForParticipants">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <h5 class="mb-1" style="font-weight: 700; color: #1e005e;">
              {{ selectedInstanceForParticipants.label || 'QR Instance' }}
              <span class="badge bg-light text-dark ms-2" style="font-size: 11px; text-transform: uppercase;">
                {{ selectedInstanceForParticipants.placement_type || 'Instance' }}
              </span>
            </h5>
            <p class="text-muted mb-0" style="font-size: 13px;" *ngIf="selectedInstanceForParticipants.short_link">
              <i class="fa-solid fa-link me-1"></i> {{ selectedInstanceForParticipants.short_link }}
            </p>
          </div>
          <div class="d-flex gap-2">
            <span class="badge bg-purple-light text-purple px-3 py-2 rounded-pill" style="font-size: 13px;" *ngIf="selectedInstanceForParticipants.scan_count !== undefined">
              <i class="fa-solid fa-qrcode me-1"></i> {{ selectedInstanceForParticipants.scan_count }} Scans
            </span>
            <span class="badge bg-primary text-white px-3 py-2 rounded-pill" style="font-size: 13px;">
              <i class="fa-solid fa-user-group me-1"></i> {{ participantsTotal }} Participants
            </span>
          </div>
        </div>
      </div>

      <!-- Participants Table -->
      <nz-table
        #participantsTable
        [nzData]="participantsList"
        [nzBordered]="true"
        [nzScroll]="{ x: '700px' }"
        [nzFrontPagination]="false"
        [nzTotal]="participantsTotal"
        [nzPageIndex]="participantsPage"
        [nzPageSize]="participantsPerPage"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50]"
        (nzPageIndexChange)="onParticipantsPageChange($event)"
        (nzPageSizeChange)="onParticipantsPageSizeChange($event)"
        [nzNoResult]="participantsEmptyTpl">
        <thead>
          <tr>
            <th nzWidth="50px">#</th>
            <th nzWidth="180px">Participant</th>
            <th nzWidth="120px">Status</th>
            <th nzWidth="180px">Location & Device</th>
            <th nzWidth="140px">Joined Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of participantsTable.data; let idx = index">
            <td>{{ (participantsPage - 1) * participantsPerPage + idx + 1 }}</td>
            <td>
              <div class="d-flex align-items-center gap-2">
                <div class="avatar-circle">
                  <i class="fa-solid fa-user"></i>
                </div>
                <div>
                  <div style="font-weight: 600; color: #141b34;">
                    {{ p.name || p.phone_number || 'Participant #' + (p.participant_id || (idx + 1)) }}
                  </div>
                  <small class="text-muted d-block" *ngIf="p.name && p.phone_number">
                    {{ p.phone_number }}
                  </small>
                  <small class="text-muted d-block" *ngIf="p.email">
                    {{ p.email }}
                  </small>
                </div>
              </div>
            </td>
            <td>
              <span class="status-badge" [ngClass]="(p.status || 'in_progress') | lowercase">
                {{ formatParticipantStatus(p.status) }}
              </span>
            </td>
            <td>
              <div style="font-size: 13px; font-weight: 500; color: #2e3b55;">
                <span *ngIf="p.region || p.country">
                  <i class="fa-solid fa-location-dot me-1 text-danger" style="font-size: 11px;"></i>
                  {{ p.region ? (p.region + ', ') : '' }}{{ p.country || '' }}
                </span>
                <span *ngIf="!p.region && !p.country" class="text-muted">-</span>
              </div>
              <small class="text-muted d-block mt-1" *ngIf="p.device_model || p.device_type" style="font-size: 11px;">
                <i class="fa-solid fa-mobile-screen me-1"></i> {{ p.device_model || p.device_type }}
              </small>
            </td>
            <td>
              <span *ngIf="p.joined_at; else noJoined">
                {{ p.joined_at | date: 'dd/MM/yy hh:mm a' }}
              </span>
              <ng-template #noJoined>
                <span *ngIf="p.registered_at; else dash">
                  {{ p.registered_at | date: 'dd/MM/yy hh:mm a' }}
                </span>
                <ng-template #dash>-</ng-template>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <ng-template #participantsEmptyTpl>
        <div class="participants-empty-state">
          <div class="empty-icon-wrap">
            <i class="fa-solid fa-user-group"></i>
          </div>
          <h5 class="empty-title">No Participants Found</h5>
          <p class="empty-desc">No users have scanned or participated via this QR instance yet.</p>
        </div>
      </ng-template>
    </div>
  </ng-container>
</nz-drawer>

<ng-template #participantsDrawerTitleTpl>
  <div class="d-flex align-items-center gap-2">
    <i class="fa-solid fa-user-group text-purple" style="font-size: 18px; color: #5304FB;"></i>
    <span style="font-weight: 700; font-size: 16px; color: #1e005e;">QR Instance Participants</span>
  </div>
</ng-template>
